import routerOptions0 from "/home/runner/work/ralph-web/ralph-web/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}